var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$mq == 'sm')?_c('mobile-navigation'):_c('Navigation'),_c('router-view'),_c('a',{staticClass:"whatsapp-chat-btn",attrs:{"href":"https://wa.me/+919395699623","target":"_blank"}},[_c('whatsapp',{attrs:{"fillColor":"#25D366"}}),_c('span',[_vm._v(" "+_vm._s(_vm.$mq == 'sm'? '' : 'WhatsApp Us')+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }